import { create } from 'zustand';

interface YearsState {
  showMobileFilter: boolean;
  setShowMobileFilter: (show: boolean) => void;
  activeYear: number | null;
  contentRefs: { [key: string]: HTMLDivElement | null };
  setActiveYear: (year: number | null) => void;
  setContentRef: (year: string, ref: HTMLDivElement | null) => void;
  scrollToYear: (year: number) => void;
  getContentRefs: () => { [key: string]: HTMLDivElement | null };
}

export const useYearsStore = create<YearsState>((set, get) => ({
  showMobileFilter: false,
  setShowMobileFilter: (show) => set({ showMobileFilter: show }),
  activeYear: new Date().getFullYear(), 
  contentRefs: {},

  setActiveYear: (year) => set({ activeYear: year }),

  setContentRef: (year, ref) =>
    set((state) => ({
      contentRefs: {
        ...state.contentRefs,
        [year]: ref,
      },
    })),

  getContentRefs: () => get().contentRefs,

  scrollToYear: (year) => {
    const { contentRefs } = get();
    const element = contentRefs[year];
    if (element) {
      const offset = 130;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth',
      });
    }
  },
}));
